var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active && !(_vm.isClient && _vm.kind === 'balance'))?_c('span',{staticClass:"shortage-mark",class:{ 'is-balance': _vm.kind === 'balance' },attrs:{"title":_vm.hint}},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }